import { Grid, Typography } from '@mui/material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import Logo from 'assets/logo.png'
import { useTranslation } from 'react-i18next'
import InstallLayout from 'router/layouts/InstallLayout'

export default function ErrorBoundaryPage() {
    const { t } = useTranslation()
    const { isMobile } = useScreenSize()

    return (
        <InstallLayout container alignItems="center">
            <Grid
                item
                container
                alignItems="center"
                justifyContent={'center'}
                spacing={2}
            >
                <Grid item>
                    <img
                        style={{
                            width: isMobile ? 340 : 412,
                        }}
                        src={Logo}
                        alt="logo"
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h4" color="white" align="center">
                        {t('error_boundary_message')}
                    </Typography>
                </Grid>
            </Grid>
        </InstallLayout>
    )
}
